import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
import debounce from 'debounce';
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import View from "react-native-web/dist/exports/View";
import React from 'react';

var normalizeScrollEvent = function normalizeScrollEvent(e) {
  return {
    nativeEvent: {
      contentOffset: {
        get x() {
          return e.target.scrollLeft;
        },

        get y() {
          return e.target.scrollTop;
        }

      },
      contentSize: {
        get height() {
          return e.target.scrollHeight;
        },

        get width() {
          return e.target.scrollWidth;
        }

      },
      layoutMeasurement: {
        get height() {
          return e.target.offsetHeight;
        },

        get width() {
          return e.target.offsetWidth;
        }

      }
    },
    timeStamp: Date.now()
  };
};
/**
 * Encapsulates the Web-specific scroll throttling and disabling logic
 */


var ScrollViewBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollViewBase, _React$Component);

  var _super = _createSuper(ScrollViewBase);

  function ScrollViewBase() {
    var _this;

    _classCallCheck(this, ScrollViewBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this._debouncedOnScrollEnd = debounce(_this._handleScrollEnd, 100);
    _this._state = {
      isScrolling: false,
      scrollLastTick: 0
    };

    _this._createPreventableScrollHandler = function (handler) {
      return function (e) {
        if (_this.props.scrollEnabled) {
          if (handler) {
            handler(e);
          }
        }
      };
    };

    _this._handleScroll = function (e) {
      e.persist();
      e.stopPropagation();
      var _this$props$scrollEve = _this.props.scrollEventThrottle,
          scrollEventThrottle = _this$props$scrollEve === void 0 ? 0 : _this$props$scrollEve; // A scroll happened, so the scroll bumps the debounce.

      _this._debouncedOnScrollEnd(e);

      if (_this._state.isScrolling) {
        // Scroll last tick may have changed, check if we need to notify
        if (_this._shouldEmitScrollEvent(_this._state.scrollLastTick, scrollEventThrottle)) {
          _this._handleScrollTick(e);
        }
      } else {
        // Weren't scrolling, so we must have just started
        _this._handleScrollStart(e);
      }
    };

    _this._setViewRef = function (element) {
      _this._viewRef = element;
    };

    return _this;
  }

  _createClass(ScrollViewBase, [{
    key: "setNativeProps",
    value: function setNativeProps(props) {
      if (this._viewRef) {
        this._viewRef.setNativeProps(props);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accessibilityLabel = _this$props.accessibilityLabel,
          accessibilityRelationship = _this$props.accessibilityRelationship,
          accessibilityRole = _this$props.accessibilityRole,
          accessibilityState = _this$props.accessibilityState,
          children = _this$props.children,
          importantForAccessibility = _this$props.importantForAccessibility,
          nativeID = _this$props.nativeID,
          onLayout = _this$props.onLayout,
          pointerEvents = _this$props.pointerEvents,
          _this$props$scrollEna = _this$props.scrollEnabled,
          scrollEnabled = _this$props$scrollEna === void 0 ? true : _this$props$scrollEna,
          showsHorizontalScrollIndicator = _this$props.showsHorizontalScrollIndicator,
          showsVerticalScrollIndicator = _this$props.showsVerticalScrollIndicator,
          style = _this$props.style,
          testID = _this$props.testID;
      var hideScrollbar = showsHorizontalScrollIndicator === false || showsVerticalScrollIndicator === false;
      return /*#__PURE__*/React.createElement(View, {
        accessibilityLabel: accessibilityLabel,
        accessibilityRelationship: accessibilityRelationship,
        accessibilityRole: accessibilityRole,
        accessibilityState: accessibilityState,
        children: children,
        importantForAccessibility: importantForAccessibility,
        nativeID: nativeID,
        onLayout: onLayout,
        onScroll: this._handleScroll,
        onTouchMove: this._createPreventableScrollHandler(this.props.onTouchMove),
        onWheel: this._createPreventableScrollHandler(this.props.onWheel),
        pointerEvents: pointerEvents,
        ref: this._setViewRef,
        style: [style, !scrollEnabled && styles.scrollDisabled, hideScrollbar && styles.hideScrollbar],
        testID: testID
      });
    }
  }, {
    key: "_handleScrollStart",
    value: function _handleScrollStart(e) {
      this._state.isScrolling = true;
      this._state.scrollLastTick = Date.now();
      var _this$props2 = this.props,
          onScrollBeginDrag = _this$props2.onScrollBeginDrag,
          onMomentumScrollBegin = _this$props2.onMomentumScrollBegin; // 这里的交互做了降级处理，当容器停止滚动就触发onScrollBeginDrag、onMomentumScrollBegin 不做详细区分

      if (onScrollBeginDrag) {
        onScrollBeginDrag(normalizeScrollEvent(e));
      }

      if (onMomentumScrollBegin) {
        onMomentumScrollBegin(normalizeScrollEvent(e));
      }
    }
  }, {
    key: "_handleScrollTick",
    value: function _handleScrollTick(e) {
      var onScroll = this.props.onScroll;
      this._state.scrollLastTick = Date.now();

      if (onScroll) {
        onScroll(normalizeScrollEvent(e));
      }
    }
  }, {
    key: "_handleScrollEnd",
    value: function _handleScrollEnd(e) {
      var _this$props3 = this.props,
          onScroll = _this$props3.onScroll,
          onScrollEndDrag = _this$props3.onScrollEndDrag,
          onMomentumScrollEnd = _this$props3.onMomentumScrollEnd;
      this._state.isScrolling = false;

      if (onScroll) {
        onScroll(normalizeScrollEvent(e));
      } // 这里的交互做了降级处理，当容器停止滚动就触发onScrollEndDrag、onMomentumScrollEnd 不做详细区分


      if (onScrollEndDrag) {
        onScrollEndDrag(normalizeScrollEvent(e));
      }

      if (onMomentumScrollEnd) {
        onMomentumScrollEnd(normalizeScrollEvent(e));
      }
    }
  }, {
    key: "_shouldEmitScrollEvent",
    value: function _shouldEmitScrollEvent(lastTick, eventThrottle) {
      var timeSinceLastTick = Date.now() - lastTick;
      return eventThrottle > 0 && timeSinceLastTick >= eventThrottle;
    }
  }]);

  return ScrollViewBase;
}(React.Component); // Chrome doesn't support e.preventDefault in this case; touch-action must be
// used to disable scrolling.
// https://developers.google.com/web/updates/2017/01/scrolling-intervention


export { ScrollViewBase as default };
var styles = StyleSheet.create({
  scrollDisabled: {
    overflowX: 'hidden',
    overflowY: 'hidden',
    touchAction: 'none'
  },
  hideScrollbar: {
    scrollbarWidth: 'none'
  }
});